import captureSentryException from '@/features/app/functions/captureSentryException';
import GenericErrorComponent from '@/features/errors/components/generic-error-component';
import CustomTrans from '@/shared/components/custom-trans';
import { Button } from '@thisisdmg/tirecloud-patterns/v2';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

function GlobalErrorElement() {
  const { t } = useTranslation();
  const error: any = useRouteError();

  const firstMount = useRef(true);
  useEffect(() => {
    if (import.meta.env.DEV && firstMount.current) {
      firstMount.current = false;
      return;
    }
    captureSentryException(error);
  }, [error]);

  return (
    <GenericErrorComponent
      errorCode={[5, 0, 0]}
      errorMessage={t('page.errors.globalCatchAllError.title')}
      errorDetails={
        <CustomTrans
          i18nKey={'page.errors.globalCatchAllError.description'}
          components={{
            ErrorDetailsElem: (
              <p className="tw:mt-4 tw:min-h-16 tw:wrap-anywhere tw:flex-center tw:text-xs tw:bg-[#FF2D3740] tw:p-2 tw:rounded-lg">
                {error.data ?? error.message ?? error.error ?? error.toString()}
              </p>
            ),
          }}
        />
      }
      actionButton={
        <div className="tc:inline-flex tc:gap-x-2">
          <Button.Solid
            color="brand"
            onClick={async () => {
              try {
                // clear all caches
                if (window.caches !== undefined) {
                  const keys = await window.caches.keys();
                  await Promise.all(keys.map((key) => window.caches.delete(key)));
                }
              } catch (e) {
                captureSentryException(e, {
                  message: 'failed to clear caches',
                  tags: {
                    feature: 'core.pwa',
                  },
                });
              }
              window.location.reload();
            }}
          >
            {t('page.errors.globalCatchAllError.reloadBtn')}
          </Button.Solid>
        </div>
      }
    />
  );
}

export default GlobalErrorElement;
